const icePattern = /(CLIPSTUDIO|CLIP STUDIO PAINT)\/(\d+\.\d+\.\d+)/;

interface openUrlParams {
  url: string;
  view: string;
}

export default new (class Ice {
  isIce() {
    return icePattern.test(navigator.userAgent);
  }

  callIce(methodName: string, params: any) {
    if (!this.isIce()) {
      return;
    }

    // callIceが呼ばれた時のカスタムイベントを発行 IE版ICEでは不要
    if (typeof window.CustomEvent === "function") {
      let callIceEvent = new CustomEvent("callIce");
      window.dispatchEvent(callIceEvent);
    }

    let uri = "callice://" + methodName;
    if (params) {
      for (const paramName in params) {
        uri +=
          "/" +
          encodeURIComponent(paramName) +
          "/" +
          encodeURIComponent(params[paramName]);
      }
    }

    location.href = uri;
  }

  openUrl(url: string, isViewInBrowser: boolean) {
    let params = { url: url } as openUrlParams;
    if (isViewInBrowser) {
      params = { ...params, view: "browser" };
    }
    this.callIce("openUrl", params);
  }

  showLogin(url = location.href, cancelUrl = location.href) {
    const params = {
      url: url,
      cancelUrl: cancelUrl
    };
    this.callIce("showLoginDialog", params);
  }

  setActiveMenu(menu: string) {
    this.callIce("setActiveMenu", { menu: menu });
  }

  inModal() {
    const modal = document.createElement("div");
    modal.id = "iceModalWall";
    modal.style;
    modal.setAttribute(
      "style",
      "z-index:9999; position:fixed; width:100%; height:100%; background-color:#000000; opacity:0.5; top:0; left:0;"
    );
    document.body.appendChild(modal);
  }

  outModal() {
    const modal = document.getElementById("iceModalWall");
    if (modal) {
      document.body.removeChild(modal);
    }
  }

  onClickLink(event: any) {
    if (this.isIce() && event.currentTarget.target == "_blank") {
      event.preventDefault();
      this.openUrl(
        event.currentTarget.href,
        event.currentTarget.target == "_blank"
      );
    }
  }

  getPixelRatio() {
    let ratio = 1;
    const windowScreenObject = window.screen as WindowScreen;
    // To account for zoom, change to use deviceXDPI instead of systemXDPI
    if (
      windowScreenObject.systemXDPI !== undefined &&
      windowScreenObject.logicalXDPI !== undefined &&
      windowScreenObject.systemXDPI > windowScreenObject.logicalXDPI
    ) {
      // Only allow for values > 1
      ratio = windowScreenObject.systemXDPI / windowScreenObject.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
    }
    return ratio;
  }

  callGetLicense(product: string) {
    let params = { product: product };
    this.callIce("callGetLicense", params);
  }

  runPaint(serial: string) {
    let params = {};
    if (serial != "") {
      params = { serial: serial };
    }
    this.callIce("runPaint", params);
  }

  bootWithSerial(serial: string) {
    this.callIce("bootWithSerial", { serial: serial });
  }

  cancelTrial() {
    this.callIce("cancelTrial", {});
  }
})();
